<!-- Modal Header -->
<div class="modal-header border-0 pb-2">
  <div class="d-flex align-items-center flex-grow-1">
    <div class="registration-icon me-3">
      <i class="bi bi-person-plus-fill"></i>
    </div>
    <div>
      <h4 class="modal-title mb-1">ใบคำขอทำบัตรสมาชิก</h4>
      <p class="text-muted mb-0 small">ระบบการจัดเก็บและจัดการ CPD Hours • สำหรับสมาชิกสมาคมผู้ประเมินค่าทรัพย์สินไทย</p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<!-- Progress Bar -->
<div class="modal-progress">
  <div class="progress">
    <div class="progress-bar bg-success" role="progressbar" [style.width.%]="getProgressPercentage()"
      [attr.aria-valuenow]="getProgressPercentage()" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
  <div class="progress-steps">
    <div class="step-container">
      <div *ngFor="let step of [1, 2]" class="step-item">
        <div class="step-circle" [class.completed]="isStepCompleted(step)" [class.current]="isStepCurrent(step)"
          [class.clickable]="step <= currentStep" (click)="goToStep(step)">
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
          <i *ngIf="isStepCurrent(step)" class="{{ getStepIcon(step) }}"></i>
          <span *ngIf="!isStepCompleted(step) && !isStepCurrent(step)">{{ step }}</span>
        </div>
        <div class="step-label">{{ getStepTitle(step) }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">

    <!-- Step 1: Application Information -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-file-earmark-text me-2"></i>ขั้นตอนที่ 1. ข้อมูลการสมัคร
        </h5>
        <p class="step-description">กรอกข้อมูลการสมัครสมาชิก</p>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label required">วุฒิการศึกษา</label>
          <select class="form-select" formControlName="educationLevel" [class.is-invalid]="hasError('educationLevel')">
            <option value="">เลือกวุฒิการศึกษา</option>
            <option *ngFor="let level of educationLevels" [value]="level.value">{{ level.label }}</option>
          </select>
          <div class="invalid-feedback" *ngIf="hasError('educationLevel')">
            {{ getErrorMessage('educationLevel') }}
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <label class="form-label required">ผู้รับรองคนที่ 1</label>
          <input type="text" class="form-control" formControlName="qualification1" 
            [class.is-invalid]="hasError('qualification1')" 
            placeholder="กรอกชื่อผู้รับรอง">
          <div class="invalid-feedback" *ngIf="hasError('qualification1')">
            {{ getErrorMessage('qualification1') }}
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <label class="form-label required">ผู้รับรองคนที่ 2</label>
          <input type="text" class="form-control" formControlName="qualification2" 
            [class.is-invalid]="hasError('qualification2')" 
            placeholder="กรอกชื่อผู้รับรอง">
          <div class="invalid-feedback" *ngIf="hasError('qualification2')">
            {{ getErrorMessage('qualification2') }}
          </div>
        </div>

        <div class="col-12 mb-3">
          <label class="form-label">เอกสารประกอบการพิจารณา</label>

          <!-- Required docs grid -->
          <div class="required-docs-panel mb-3">
            <div class="required-docs-panel-header">
              <i class="bi bi-list-check me-2"></i>
              เอกสารที่ต้องเตรียม <span class="badge-count">9 รายการ</span>
              <span class="format-hint">PDF, JPG, JPEG, PNG • ไม่เกิน 5MB ต่อไฟล์</span>
            </div>
            <div class="required-docs-grid">
              <div class="required-doc-chip" *ngFor="let doc of requiredDocLabels; let i = index">
                <span class="chip-num">{{ i + 1 }}</span>
                <span class="chip-text">{{ doc }}</span>
              </div>
            </div>
          </div>

          <!-- Hidden file input -->
          <input
            type="file"
            #fileInputMultiple
            id="files-upload"
            accept=".pdf,.jpg,.jpeg,.png"
            (change)="onFilesSelected($event)"
            hidden>

          <!-- Drag & drop upload zone -->
          <div class="upload-zone"
            [class.drag-over]="isDragOver"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInputMultiple.click()">
            <div class="upload-zone-icon">
              <i class="bi bi-cloud-arrow-up-fill"></i>
            </div>
            <p class="upload-zone-title">
              ลากไฟล์มาวางที่นี่ หรือ <span class="upload-zone-cta">คลิกเพื่อเลือกไฟล์</span>
            </p>
            <p class="upload-zone-hint">สามารถเลือกได้หลายไฟล์พร้อมกัน</p>
          </div>

          <!-- Selected file display -->
          <div class="files-container" *ngIf="uploadedFile">
            <div class="file-row">
              <div class="file-row-icon" [ngClass]="getFileIconClass(uploadedFile.name)">
                <i class="bi" [ngClass]="getFileIcon(uploadedFile.name)"></i>
              </div>
              <div class="file-row-info">
                <p class="file-row-name">{{ uploadedFile.name }}</p>
                <p class="file-row-size">{{ formatFileSize(uploadedFile.size) }}</p>
              </div>
              <button type="button" class="btn-change-file" (click)="fileInputMultiple.click(); $event.stopPropagation()">
                <i class="bi bi-arrow-repeat me-1"></i>เปลี่ยนไฟล์
              </button>
              <button type="button" class="btn-remove-file" (click)="removeFile(); $event.stopPropagation()" title="ลบไฟล์">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: General Information and Review -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-person-check me-2"></i>ขั้นตอนที่ 2. ตรวจสอบข้อมูลและยืนยัน
        </h5>
        <p class="step-description">ตรวจสอบข้อมูลส่วนตัวและข้อมูลการสมัครให้ถูกต้อง</p>
      </div>

      <!-- Review Section (Part of Step 2) -->
      <div class="review-container mt-4">
        <!-- Application Information Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-file-earmark-text me-2"></i>ข้อมูลการสมัคร
          </h6>
          <div class="review-grid">
            <div class="review-item">
              <span class="review-label">วุฒิการศึกษา:</span>
              <span class="review-value">
                {{ getEducationLevelLabel() }}
              </span>
            </div>
            <div class="review-item">
              <span class="review-label">ผู้รับรองคนที่ 1:</span>
              <span class="review-value">{{ registrationForm.get('qualification1')?.value || '-' }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">ผู้รับรองคนที่ 2:</span>
              <span class="review-value">{{ registrationForm.get('qualification2')?.value || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- Uploaded Documents Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-paperclip me-2"></i>เอกสารประกอบการพิจารณา
          </h6>
          <div class="review-files-list" *ngIf="uploadedFile">
            <div class="review-file-item">
              <div class="review-file-icon" [ngClass]="getFileIconClass(uploadedFile.name)">
                <i class="bi" [ngClass]="getFileIcon(uploadedFile.name)"></i>
              </div>
              <div class="review-file-info">
                <span class="review-file-name">{{ uploadedFile.name }}</span>
                <span class="review-file-size">{{ formatFileSize(uploadedFile.size) }}</span>
              </div>
              <span class="review-file-badge">
                <i class="bi bi-check-circle-fill me-1"></i>พร้อมอัพโหลด
              </span>
            </div>
          </div>
          <div *ngIf="!uploadedFile" class="review-no-files">
            <i class="bi bi-exclamation-circle me-2"></i>ยังไม่ได้เลือกเอกสาร
          </div>
        </div>

        <!-- Confirmation Message -->
        <div class="alert alert-info mt-4">
          <i class="bi bi-info-circle me-2"></i>
          <strong>หมายเหตุ:</strong> กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่ม "ส่งคำขอสมัคร" หากต้องการแก้ไขข้อมูล สามารถกดปุ่ม "ย้อนกลับ" เพื่อแก้ไขได้
        </div>
      </div>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="prevStep()" *ngIf="currentStep > 1"
    [disabled]="isSubmitting">
    <i class="bi bi-arrow-left me-1"></i>ย้อนกลับ
  </button>
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isSubmitting">
    ยกเลิก
  </button>
  <button type="button" class="btn btn-success" (click)="nextStep()" *ngIf="currentStep < totalSteps"
    [disabled]="isSubmitting">
    ถัดไป<i class="bi bi-arrow-right ms-1"></i>
  </button>
  <button type="button" class="btn btn-success" (click)="onSubmit()" *ngIf="currentStep === totalSteps"
    [disabled]="isSubmitting || registrationForm.invalid">
    <span *ngIf="!isSubmitting">
      <i class="bi bi-check-circle me-1"></i>ยืนยันและส่งข้อมูล
    </span>
    <span *ngIf="isSubmitting">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      กำลังส่งข้อมูล...
    </span>
  </button>
</div>
